import { useEffect, useState } from 'react'
import { krakenAPI } from '../services/krakenApi'
import { useAuthStore } from '../store/authStore'

// One request per login, shared by every component that asks: the answer
// (superuser + KRAKEN_ALLOWED_EMAILS, decided server-side) does not change
// within a session. Keyed by token so a different login asks again.
let cached: Promise<boolean> | null = null
let cachedFor: string | null = null

/** Forget the cached answer (tests). */
export const resetKrakenAccess = () => {
  cached = null
  cachedFor = null
}

/**
 * Whether this user passes the server's live-trading gate (/api/kraken/access).
 * False until the answer arrives and on any error: the gated controls stay
 * hidden rather than flash in. Hiding is presentation only -- every gated
 * endpoint enforces the same rule server-side.
 */
const useKrakenAccess = (): boolean => {
  const token = useAuthStore((state) => state.token)
  const [allowed, setAllowed] = useState(false)
  useEffect(() => {
    let live = true
    if (!token) {
      setAllowed(false)
      return
    }
    if (!cached || cachedFor !== token) {
      cachedFor = token
      cached = krakenAPI
        .access()
        .then((a) => Boolean(a.allowed))
        .catch(() => {
          cached = null
          return false
        })
    }
    cached.then((ok) => live && setAllowed(ok))
    return () => {
      live = false
    }
  }, [token])
  return allowed
}

export default useKrakenAccess
